/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerGetInternalConversationHistoryQueryResponse, MultiDocumentAgentControllerGetInternalConversationHistoryPathParams, MultiDocumentAgentControllerGetInternalConversationHistoryQueryParams, MultiDocumentAgentControllerGetInternalConversationHistory400, MultiDocumentAgentControllerGetInternalConversationHistory401, MultiDocumentAgentControllerGetInternalConversationHistory403, MultiDocumentAgentControllerGetInternalConversationHistory404 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerGetInternalConversationHistory";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { multiDocumentAgentControllerGetInternalConversationHistory } from "../../clients/multi-document-agentService/multiDocumentAgentControllerGetInternalConversationHistory";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const multiDocumentAgentControllerGetInternalConversationHistoryQueryKey = (requestId: MultiDocumentAgentControllerGetInternalConversationHistoryPathParams["requestId"], params: MultiDocumentAgentControllerGetInternalConversationHistoryQueryParams = {}) => [{
  url: '/api/v1/multi-document-agent/internal-history/:requestId',
  params: {
    requestId: requestId
  }
}, ...(params ? [params] : [])] as const;
export type MultiDocumentAgentControllerGetInternalConversationHistoryQueryKey = ReturnType<typeof multiDocumentAgentControllerGetInternalConversationHistoryQueryKey>;
export function multiDocumentAgentControllerGetInternalConversationHistoryQueryOptions(requestId: MultiDocumentAgentControllerGetInternalConversationHistoryPathParams["requestId"], params?: MultiDocumentAgentControllerGetInternalConversationHistoryQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = multiDocumentAgentControllerGetInternalConversationHistoryQueryKey(requestId, params);
  return queryOptions<MultiDocumentAgentControllerGetInternalConversationHistoryQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerGetInternalConversationHistory400 | MultiDocumentAgentControllerGetInternalConversationHistory401 | MultiDocumentAgentControllerGetInternalConversationHistory403 | MultiDocumentAgentControllerGetInternalConversationHistory404>, MultiDocumentAgentControllerGetInternalConversationHistoryQueryResponse, typeof queryKey>({
    enabled: !!requestId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return multiDocumentAgentControllerGetInternalConversationHistory(requestId, params, config);
    }
  });
}

/**
 * @description Returns the internal conversation history message (category=in-progress, subCategory=internal-conversation-history) for debugging and analysis. Requires System Administrator role.
 * @summary Get internal conversation history for a request (System Admin only)
 * {@link /api/v1/multi-document-agent/internal-history/:requestId}
 */
export function useMultiDocumentAgentControllerGetInternalConversationHistory<TData = MultiDocumentAgentControllerGetInternalConversationHistoryQueryResponse, TQueryData = MultiDocumentAgentControllerGetInternalConversationHistoryQueryResponse, TQueryKey extends QueryKey = MultiDocumentAgentControllerGetInternalConversationHistoryQueryKey>(requestId: MultiDocumentAgentControllerGetInternalConversationHistoryPathParams["requestId"], params?: MultiDocumentAgentControllerGetInternalConversationHistoryQueryParams, options: {
  query?: Partial<QueryObserverOptions<MultiDocumentAgentControllerGetInternalConversationHistoryQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerGetInternalConversationHistory400 | MultiDocumentAgentControllerGetInternalConversationHistory401 | MultiDocumentAgentControllerGetInternalConversationHistory403 | MultiDocumentAgentControllerGetInternalConversationHistory404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? multiDocumentAgentControllerGetInternalConversationHistoryQueryKey(requestId, params);
  const query = useQuery({
    ...multiDocumentAgentControllerGetInternalConversationHistoryQueryOptions(requestId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<MultiDocumentAgentControllerGetInternalConversationHistory400 | MultiDocumentAgentControllerGetInternalConversationHistory401 | MultiDocumentAgentControllerGetInternalConversationHistory403 | MultiDocumentAgentControllerGetInternalConversationHistory404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}